import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Bandeau "enveloppe dépassée" — affiché uniquement quand la mission sélectionnée
 * a consommé plus que son enveloppe (cons > env).
 */
export default function MissionEnvelopeOverflowBanner({ mission }) {
  const env = Number(mission.envelope_jh || 0);
  const cons = Number(mission.consumed_jh || 0);
  const overBy = (cons - env).toLocaleString(undefined, { maximumFractionDigits: 2 });
  return (
    <div
      data-testid="mission-envelope-overflow-banner"
      className="mt-4 px-5 py-4 rounded-lg border border-red-300 bg-red-50 text-red-900 flex items-start gap-3"
    >
      <AlertTriangle size={18} className="text-red-600 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-semibold">Enveloppe dépassée — {mission.title}</div>
        <div className="mt-0.5 opacity-90">
          {cons.toLocaleString(undefined, { maximumFractionDigits: 2 })} j consommés sur une enveloppe de{" "}
          {env.toLocaleString(undefined, { maximumFractionDigits: 2 })} j (dépassement de <strong>{overBy} j</strong>).
          Rapprochez-vous de votre manager pour valider la suite de l'imputation.
        </div>
      </div>
    </div>
  );
}
